"use client";

import { Loader2 } from "lucide-react";

type LoadingScreenProps = {
  container?: boolean;
};

export function LoadingScreen({ container = false }: LoadingScreenProps) {
  let cls =
    "inset-0 flex items-center justify-center bg-background text-foreground z-50 absolute";
  if (container) {
    cls = cls.replace("absolute", "w-full h-full");
  }

  return (
    <div className={cls}>
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary-foreground" />
      </div>
    </div>
  );
}
